// extracted by mini-css-extract-plugin
export var phone = "_4t-0";